export enum TokenRegisterType {
  Email = '1',
  SMS = '2'
}